import CurrencyFormat from 'react-currency-format';
import { useSelector } from 'react-redux';
import { Table as RSTable } from 'rsuite';
import { PriceExtraction } from '../../../../../@types/IPA/PriceExtraction';
import { BaseCell } from '../../../../../components';
import { selectorIsWholesaleEnabled } from '../../../../../reducers/reducerIPA/channels';
import { useEffectiveDateEnabled } from '../../../../Administrador/Produtos/Components/SetupIpaBasicConfig/hooks/useEffectiveDateEnabled';
import PriceStatusIndicator from '../../../RevisaoPrecos/Components/PriceStatusIndicator/PriceStatusIndicator';
import styles from './Table.module.scss';
import { useTable } from './useTable';
import { formatEffectiveStartDate, normalizeWholesaleValue } from './utils';

type RowData = PriceExtraction['rowData'];

const { Column, HeaderCell, Cell, Pagination } = RSTable;

export const Table = () => {
  const { datapoints, pagination, isLoading, actions } = useTable();
  const isWholesaleEnabled = useSelector(selectorIsWholesaleEnabled);
  const { isEnabled: isEffectiveDateEnabled } = useEffectiveDateEnabled();

  return (
    <>
      <RSTable data={datapoints} headerHeight={46} rowHeight={46} loading={isLoading} height={400} autoHeight className={styles.table}>
        {/* @ts-ignore */}
        <Column flexGrow={3}>
          <HeaderCell>Produto</HeaderCell>
          <Cell>
            {(rowData: RowData) => (
              <BaseCell>
                <span>
                  <strong>{rowData.productId}</strong> - {rowData.description}
                </span>
              </BaseCell>
            )}
          </Cell>
        </Column>
        {/* @ts-ignore */}
        <Column flexGrow={2}>
          <HeaderCell>Loja</HeaderCell>
          <Cell>
            {(rowData: RowData) => (
              <BaseCell>
                {rowData.storeId} - {rowData.storeName}
              </BaseCell>
            )}
          </Cell>
        </Column>

        {/* @ts-ignore */}
        <Column flexGrow={1}>
          <HeaderCell>Preço regular</HeaderCell>
          <Cell>
            {(rowData: RowData) => (
              <BaseCell>
                <BaseCell.MainContainer>
                  <CurrencyFormat
                    fixedDecimalScale
                    decimalScale={2}
                    value={rowData.price ?? ''}
                    displayType="text"
                    prefix="R$ "
                    decimalSeparator=","
                    thousandSeparator="."
                  />
                </BaseCell.MainContainer>
              </BaseCell>
            )}
          </Cell>
        </Column>
        {isWholesaleEnabled && (
          /* @ts-ignore */
          <Column flexGrow={1}>
            <HeaderCell>Preço Atacado</HeaderCell>
            <Cell>
              {(rowData: RowData) => {
                const wholesaleValue = normalizeWholesaleValue(rowData?.wholesale);

                return (
                  <BaseCell>
                    <BaseCell.MainContainer>
                      {wholesaleValue !== null ? (
                        <CurrencyFormat
                          fixedDecimalScale
                          decimalScale={2}
                          value={wholesaleValue}
                          displayType="text"
                          prefix="R$ "
                          decimalSeparator=","
                          thousandSeparator="."
                        />
                      ) : null}
                    </BaseCell.MainContainer>
                  </BaseCell>
                );
              }}
            </Cell>
          </Column>
        )}
        {/* @ts-ignore */}
        <Column flexGrow={1}>
          <HeaderCell>Preço Oferta</HeaderCell>
          <Cell>
            {(rowData: RowData) => (
              <BaseCell>
                <BaseCell.MainContainer>
                  <CurrencyFormat
                    fixedDecimalScale
                    decimalScale={2}
                    value={rowData?.offer ?? ''}
                    displayType="text"
                    prefix="R$ "
                    decimalSeparator=","
                    thousandSeparator="."
                  />
                </BaseCell.MainContainer>
              </BaseCell>
            )}
          </Cell>
        </Column>
        {isEffectiveDateEnabled && (
          /* @ts-ignore */
          <Column flexGrow={1}>
            <HeaderCell>Data vigência</HeaderCell>
            <Cell>
              {(rowData: RowData) => (
                <BaseCell>
                  <BaseCell.MainContainer>{formatEffectiveStartDate(rowData.effectiveStartDate)}</BaseCell.MainContainer>
                </BaseCell>
              )}
            </Cell>
          </Column>
        )}
        {/* @ts-ignore */}
        <Column flexGrow={1} verticalAlign="middle">
          <HeaderCell>Status de Preço</HeaderCell>
          <Cell>{(rowData: RowData) => <PriceStatusIndicator priceStatus={rowData.priceStatus} />}</Cell>
        </Column>
      </RSTable>
      <Pagination {...pagination} onChangeLength={actions.handleChangePageSize} onChangePage={actions.handleChangePage} />
    </>
  );
};
